import { getPhoneCodeByTimezone } from 'timezone-phone-codes';
import ct from 'countries-and-timezones';
import countries from 'shared/constants/countries.js';

export const PHONE_COUNTRY_NONE = 'none';

const getTimezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;

export const getActiveDialCode = () => {
  return getPhoneCodeByTimezone(getTimezone()) || '';
};

export const getActiveCountryCode = () => {
  const country = ct.getCountryForTimezone(getTimezone()) || {};
  return country.id || '';
};

/**
 * Translate a country name from the COUNTRIES dictionary, falling back to the English name.
 * Looks the name up directly because vue-i18n reads dots in a key path as nesting
 * ("Virgin Islands, U.S.").
 */
export const getCountryName = ({ tm, rt }, name) => {
  const message = tm('COUNTRIES')[name];
  return message ? rt(message) : name;
};

/**
 * Resolve the country preselected in a phone input from the inbox setting.
 * An empty or unknown setting falls back to the visitor's timezone,
 * PHONE_COUNTRY_NONE leaves the country unselected, an ISO code forces that country.
 */
export const getDefaultPhoneCountry = setting => {
  if (setting === PHONE_COUNTRY_NONE) {
    return { countryCode: '', dialCode: '' };
  }
  const country = setting && countries.find(({ id }) => id === setting);
  if (country) {
    return { countryCode: country.id, dialCode: country.dial_code };
  }
  return { countryCode: getActiveCountryCode(), dialCode: getActiveDialCode() };
};
